import React from "react";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";
import { Home } from "lucide-react";

export default function NotFound() {
  const [, navigate] = useLocation();

  return (
    <div className="flex items-center justify-center min-h-screen bg-background" data-testid="page-not-found">
      <div className="text-center space-y-4 max-w-md p-6">
        <h1 className="text-4xl font-bold" data-testid="text-404-title">404</h1>
        <p className="text-xl text-muted-foreground" data-testid="text-404-message">
          Page not found
        </p>
        <p className="text-sm text-muted-foreground" data-testid="text-404-description">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Button
          onClick={() => navigate("/")}
          className="gap-2"
          data-testid="button-back-home"
        >
          <Home className="h-4 w-4" />
          Back to Home
        </Button>
      </div>
    </div>
  );
}
